const isLocalHost = document.location.host.startsWith('localhost:') ? true : false;
export const API_HOST = isLocalHost ? `http://localhost:3000` :  document.location.origin;
